module.exports = __webpack_public_path__ + "img/2.595b1268.png";